export default class ConfigurationValue {
    public id: string = '';
    public configurationSetId: string = '';
    public name: string | undefined;
    public value: string | undefined;

    public constructor(partial?: Partial<ConfigurationValue>) {
        Object.assign(this, partial);
    }
}